import React from 'react'
import './title.scss'

const Title = ({ text }) => {
  return <div className="title">{text}</div>
}

export default Title
